import { render } from "./limit-login-attempts.vue?vue&type=template&id=5a942aa6&scoped=true"
import script from "./limit-login-attempts.vue?vue&type=script&lang=js"
export * from "./limit-login-attempts.vue?vue&type=script&lang=js"

import "./limit-login-attempts.vue?vue&type=style&index=0&id=5a942aa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a942aa6"]])

export default __exports__